import React from "react"
import styled from "styled-components"

import {Label1} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"
import {minWidthMedia} from "@irati/ui/src/global/media"
import DefaultLoader from "@irati/ui/src/Loading/Loader"

export const StyledLabel1 = styled(Label1).attrs({bold: true, uppercase: false})`
  margin-top: 20px;
  color: ${greys.mediumLight};

  ${minWidthMedia.tablet`
      margin-top: 30px;
    `}
`

export const Inner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${minWidthMedia.tablet`
    margin: 0 auto;
    max-width: 300px;
  `}
`

export const WrappedLoader = styled.div.attrs({
  children: <DefaultLoader />
})``
